import React, {
  createContext, useEffect, useMemo, useReducer, useState,
} from 'react';
import { useNavigate } from 'react-router-dom';
import { changeMemberPassword, login } from '../api/authAPI';
import { getMyInfo } from '../api/memberAPI';

const AuthContext = createContext<AuthContextType | null>(null);

export const AuthReducerAction = {
  LOGIN: '@auth/login',
  LOGOUT: '@auth/logout',
};

const initialState = {
  user: null,
};

// eslint-disable-next-line @typescript-eslint/default-param-last
const authReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case AuthReducerAction.LOGIN: {
      const { user } = action.payload!;
      return {
        user,
      };
    }
    case AuthReducerAction.LOGOUT: {
      return {
        user: null,
      };
    }
    default: {
      return { ...state };
    }
  }
};

export const AuthProvider = ({ children }: { children: React.ReactElement }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);

  const [checkingAuth, setCheckingAuth] = useState(true);
  const loginUser = async (email:string, password:string) => {
    const result = await login(email, password);
    dispatch({
      type: AuthReducerAction.LOGIN,
      payload: {
        user: result,
      },
    });
    localStorage.setItem('serviceToken', result.accessToken ?? '');
 
    if (!result.isResetPassword) {
      window.location.href = '/password/reset';
    } else {
      window.location.href = '/recommend';
      console.log('login');
    }
  };
  const logoutUser = () => {
    localStorage.removeItem('serviceToken');
    window.location.href = '/login';
    dispatch({
      type: AuthReducerAction.LOGOUT,
      payload: {},
    });
  };
  const changePassword = async (prePassword:string, newPassword:string) => {
    console.log(state);
    await changeMemberPassword(prePassword, newPassword, state.user.memberId);
  };
  const checkAuth = async (toLogin:boolean) => {
    if (state.user) {
      return;
    }
    const accessToken = localStorage.getItem('serviceToken');
    if (!accessToken) {
      if (toLogin) {
        logoutUser();
      }
      setCheckingAuth(false);
      return;
    }
    try {
      const userInfo = await getMyInfo();
      dispatch({
        type: AuthReducerAction.LOGIN,
        payload: {
          user: userInfo,
        },
      });
    } catch (e) {
      if (toLogin) {
        logoutUser();
      }
    }
    setCheckingAuth(false);
  };
  useEffect(() => {
    checkAuth(false).catch((r) => {
    });
  }, []);
  return (
    <>
      {/* eslint-disable-next-line react/jsx-no-constructed-context-values */}
      <AuthContext.Provider value={{
        ...state, loginUser, logoutUser, changePassword, checkAuth, checkingAuth,
      }}
      >
        {children}
      </AuthContext.Provider>
    </>
  );
};

export default AuthContext;
